module.exports = __webpack_public_path__ + "img/initial1923.f01c5dcd.png";